/**
 * @enum {String}
 */
module.exports = {
    SMS: 'sms',
    EMAIL: 'email'
};
